import { ApolloClient, useApolloClient } from '@apollo/client'
import { useCallback } from 'react'

import {
  InboxTaskListItemCompletionFragment,
  InboxTaskListItemCompletionFragmentDoc,
} from 'generated/resources/graphql'

export const TASK_CACHE_PREFIX = 'TasksInboxTask'

export const readTaskFromCache = (
  apolloClient: ApolloClient<object>,
  taskId: string
): InboxTaskListItemCompletionFragment | null =>
  apolloClient.readFragment({
    id: `${TASK_CACHE_PREFIX}:${taskId}`,
    fragment: InboxTaskListItemCompletionFragmentDoc,
    fragmentName: 'InboxTaskListItemCompletion',
  })

export const writeTaskToCache = (
  apolloClient: ApolloClient<object>,
  taskId: string,
  data: InboxTaskListItemCompletionFragment
) =>
  apolloClient.writeFragment({
    id: `${TASK_CACHE_PREFIX}:${taskId}`,
    fragment: InboxTaskListItemCompletionFragmentDoc,
    fragmentName: 'InboxTaskListItemCompletion',
    data,
  })

export const useMarkTaskAsDoneInCache = () => {
  const apolloClient = useApolloClient()

  return useCallback(
    (taskId: string) =>
      writeTaskToCache(apolloClient, taskId, {
        __typename: 'TasksInboxTask',
        id: taskId,
        completedAt: new Date().toISOString(),
        status: 'done',
      }),
    [apolloClient]
  )
}
